import {
  BarsOutlined,
  BorderlessTableOutlined,
  FallOutlined,
  RiseOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
} from '@ant-design/icons';
import classNames from 'classnames';

import Button from '~/shared/components/form-fields/button';
import Tools from '~/shared/components/tools';
import { LIST_VIEW_TYPE } from '~/shared/constants';
import type { I18nextOptionsType } from '~/shared/types/i18n-type';

import '~/shared/components/sort-bar/sort-bar.scss';
import { useTypedTranslation } from '~/shared/hooks';
import ResponsiveTooltip from '~/shared/components/responsive-tooltip';

type SortBarPropsType = {
  viewType: string;
  sort: string;
  t: (key: string, options: I18nextOptionsType) => string;
  setSort: (sort: string) => void;
  setViewType?: (viewType: string) => void;
};

const SortBar = ({ setViewType, setSort, sort, viewType }: SortBarPropsType) => {
  const t = useTypedTranslation(['text']);

  return (
    <Tools className="sort-bar">
      {setSort && (
        <Button style={{ marginRight: 4 }} onClick={() => setSort(sort === 'TITLE_ASC' ? 'TITLE_DESC' : 'TITLE_ASC')}>
          {sort === 'TITLE_ASC' ? <SortAscendingOutlined /> : <SortDescendingOutlined />}
        </Button>
      )}
      {setSort && (
        <Button
          style={{ marginRight: 10 }}
          className={classNames('main-button', 'small-button')}
          onClick={() => setSort(sort === '_ID_ASC' ? '_ID_DESC' : '_ID_ASC')}
        >
          {sort === '_ID_ASC' ? <FallOutlined /> : <RiseOutlined />}
        </Button>
      )}
      <ResponsiveTooltip title={t('text.tile-view')}>
        {setViewType && (
          <Button
            type={viewType === LIST_VIEW_TYPE.TILE ? 'primary' : 'text'}
            className={classNames(
              'main-button',
              'small-button',
              'view-button',
              viewType === LIST_VIEW_TYPE.TILE && 'selected',
            )}
            style={{ marginRight: 4 }}
            onClick={() => setViewType(LIST_VIEW_TYPE.TILE)}
          >
            <BorderlessTableOutlined />
          </Button>
        )}{' '}
      </ResponsiveTooltip>
      <ResponsiveTooltip title={t('text.row-view')}>
        {setViewType && (
          <Button
            type={viewType !== LIST_VIEW_TYPE.TILE ? 'primary' : 'text'}
            onClick={() => setViewType(LIST_VIEW_TYPE.ROW)}
          >
            <BarsOutlined />
          </Button>
        )}{' '}
      </ResponsiveTooltip>
    </Tools>
  );
};

export default SortBar;
